<template>
    <div class="login-container">
        <div class="login-box">
            <div class="tips">
                登录后可以保存您的浏览喜好、评论、收藏，并与APP同步，更可以发布微头条
            </div>
            <div class="login">登录</div>
            <div class="way">
                <div class="qq clearfix">
                    <div class="fr">
                        <div class="qq-img">
                            <i class="icon iconfont icon-QQ2"></i>
                        </div>
                        <div class="qq-txt">QQ</div>
                    </div>
                </div>
                <div class="wx clearfix">
                    <div class="fl">
                        <div class="wx-img">
                            <i class="icon iconfont icon-weixin1"></i>
                        </div>
                        <div class="wx-txt">微信</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LoginComponent',
    data() {
        return {}
    }
}
</script>
<style lang="scss" scoped>
@import './LoginComponent.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/login/LoginComponent.vue